import { Phone, Mail, Facebook, Instagram, Linkedin, Youtube, ArrowUpRight } from "lucide-react";
import { TikTokIcon } from "./icons";
import { useLanguage } from "@/context/LanguageContext";
import { track } from "@/lib/analytics";
import { CONTACT } from "@/lib/copy";

const SCHEDULE_LINK = `${CONTACT.whatsappLink}?text=${encodeURIComponent("Hola DEVOLUZION, quiero agendar una llamada.")}`;

export default function TopBar() {
  const { t } = useLanguage();
  const socials = [
    { icon: Facebook, href: CONTACT.facebook, label: "Facebook", testid: "topbar-facebook" },
    { icon: Linkedin, href: CONTACT.linkedin, label: "LinkedIn", testid: "topbar-linkedin" },
    { icon: Instagram, href: CONTACT.instagram, label: "Instagram", testid: "topbar-instagram" },
    { icon: Youtube, href: CONTACT.youtube, label: "YouTube", testid: "topbar-youtube" },
    { icon: TikTokIcon, href: CONTACT.tiktok, label: "TikTok", testid: "topbar-tiktok" },
  ];

  return (
    <div
      className="fixed inset-x-0 top-0 z-[82] border-b border-white/5 bg-ink/80 backdrop-blur-xl"
      data-testid="topbar"
    >
      <div className="mx-auto flex h-11 max-w-7xl items-center justify-between gap-4 px-6">
        <div className="flex items-center gap-5">
          <a
            href={`tel:${CONTACT.whatsapp.replace(/\s/g, "")}`}
            data-testid="topbar-phone"
            className="flex items-center gap-1.5 font-mono text-[14px] tracking-wide text-zinc-400 transition-colors duration-300 hover:text-white"
          >
            <Phone className="h-[15px] w-[15px] text-volt" />
            {CONTACT.whatsapp}
          </a>
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="topbar-email"
            className="hidden items-center gap-1.5 font-mono text-[14px] tracking-wide text-zinc-400 transition-colors duration-300 hover:text-white sm:flex"
          >
            <Mail className="h-[15px] w-[15px] text-volt" />
            {CONTACT.email}
          </a>
        </div>

        <div className="flex items-center gap-5">
          <div className="hidden items-center gap-3.5 md:flex">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={s.testid}
                onClick={() => track(`click_${s.label.toLowerCase()}`, {})}
                className="text-zinc-400 transition-colors duration-300 hover:text-volt"
              >
                <s.icon className="h-[18px] w-[18px]" />
              </a>
            ))}
          </div>
          <p className="hidden text-[14px] text-zinc-400 lg:block" data-testid="topbar-text">
            {t.topbar.text}
          </p>
          <a
            href={SCHEDULE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="topbar-agendar"
            className="group flex items-center gap-1.5 rounded-full bg-volt px-4 py-1.5 text-[14px] font-medium text-onvolt transition-colors duration-300 hover:bg-white hover:text-black"
          >
            {t.topbar.cta}
            <ArrowUpRight className="h-[15px] w-[15px] transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </div>
      </div>
    </div>
  );
}
